export default {"src":"/_next/static/media/highcontrast-search.83dcd63e.svg","height":40,"width":40};